import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const ChangesInThisPrivacyStatement = () => {
  return (
    <>
      <Subtitle>Changes in this Privacy Statement</Subtitle>
      <Paragraph>
        Glints reserves the right to update, revise, modify or amend this
        Privacy Statement at any time as Glints deems necessary, so you are
        strongly recommended to review this Privacy Statement frequently. If
        Glints decides to update, revise, modify or amend this Privacy
        Statement, Glints will post those changes to this webpage and/or other
        places as Glints deems appropriate, so that you would be aware of what
        information Glints collects, how Glints uses it, and under what
        circumstances, if any, Glints discloses it.
      </Paragraph>
      <Paragraph>
        If Glints makes material changes to this Privacy Statement, Glints will
        notify you on this webpage, by email, or by means of a notice on the
        home page of Glints.
      </Paragraph>
      <Paragraph>
        Such changes to this Privacy Statement shall apply from the time that
        Glints posts the same on this webpage. Your continued use of the Site
        and services on the Site shall constitute acceptance of the changes to
        this Privacy Statement.
      </Paragraph>
    </>
  );
};
